import axios from "axios";
import { api } from "./api_route";

export const allArbitrators = async (values) => {
  try {
    const result = await axios.get(`${api}/boardsAndPanel/allArbitrators`);
    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelEmpanelmentRegistrationView = async (values) => {
  try {
    const result = await axios.get(`${api}/boardsAndPanel/view/${values}`);

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    console.log(error.message);
    return [];
  }
};

export const boardsAndPanelEmpanelmentRegistrationDocumentView = async (
  values
) => {
  try {
    const result = await axios.get(
      `${api}/empanelRegistrationDocument/${values}`,
      {
        responseType: "blob",
      }
    );

    const blob = new Blob([result.data], {
      type: result.headers["content-type"] || "image/png",
    });

    const objectUrl = URL.createObjectURL(blob);

    return {
      data: blob,
      objectUrl: objectUrl,
      fileName: values,
      contentType: result.headers["content-type"],
      status: result.status,
    };
  } catch (error) {
    console.log("Error:", error.message);
    return { error: error.message };
  }
};

export const boardsAndPanelEmpanelmentFetchDocument = async (values) => {
  try {
    const result = await axios.get(
      `${api}/boardsAndPanel/fetchDocument/${values}`
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    console.log(error.message);
    return [];
  }
};

export const boardsAndPanelEmpanelmentProfessionalRegistration = async (
  values
) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/professionalRegistration`,
      values,
      values
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelEmpanelmentPersonalDetails = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/empanelmentPersonalDetails`,
      values
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelEmpanelmentProfessionalDetails = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/professionalDetails`,
      values
    );

    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelEmpanelmentRegistrationReviewAndApproval = async (
  values
) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/reviewAndApproval/${values.id}`,
      values
    );
    return result;
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelEmpanelmentRegReOpen = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/empanelmentRegReOpen/${values.id}`,
      values
    );
    return result;
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelEmpanelMembershipStatus = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/empanelMembershipStatus/${values.id}`,
      values
    );
    return result;
  } catch (error) {
    return [];
  }
};

//Mediator

export const allMediators = async (values) => {
  try {
    const result = await axios.get(`${api}/boardsAndPanel/allMediators`);
    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelMediatorReviewAndApproval = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/mediatorsReviewAndApproval/${values.id}`,
      values
    );
    return result;
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelMediatorsEmpanelmentRegReOpen = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/mediatorsEmpanelmentRegReOpen/${values.id}`,
      values
    );
    return result;
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelMediatorsStatus = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/mediatorsEmpanelMembershipStatus/${values.id}`,
      values
    );
    return result;
  } catch (error) {
    return [];
  }
};

export const boardsAndPanelMediatorResendCertificateAPI = async (id) => {
  try {
    const response = await axios.post(
      `${api}/boardsAndPanel/mediatorResendCertificate/${id}`
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const boardsAndPanelEmpanelmentRenewalCopyRecord = async () => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/empanelmentRenewalCopyRecord`
    );
    return result;
  } catch (error) {
    return [];
  }
};
